import React, { useLayoutEffect, useRef, useState } from 'react'
import { Box, Button, Stack } from '@mui/material'

import Modal from '../../common/modal'
import { SuccessPopUp } from '../../common/snippets'

import LRTable from './LRTable'
import LineinputV2 from '../../common/lineinputV2'
import { formatTripDateTime } from './helpers'
import { useSetAtom } from 'jotai'
import { alertAtom } from '../../common/jotaiState/globalStateAtoms'

const LoadEditorModal = ({
  open,
  mode = 'add',
  trip,
  lrRows = [],
  maximumWeight = 0,
  loadedWeight = 0,
  availableWeight = 0,
  selectedWeight = 0,

  onSelectionChange,

  onSave,
  onClose,
  onLoadPendency,
  isLoading = false,
}) => {
  const [showOverloadConfirmation, setShowOverloadConfirmation] = useState(false)
  const overloadAmount = Number(selectedWeight) - Number(maximumWeight)
  const containerRef = useRef(null);
  const [tableHeight, setTableHeight] = useState(400);
  const setAlert = useSetAtom(alertAtom )


  useLayoutEffect(() => {
    if (!containerRef.current) return;
  
    const parent = containerRef.current.parentElement;
    if (!parent) return;
  
    const updateHeight = () => {
      const parentHeight = parent.clientHeight;
      const topOffset = containerRef.current.offsetTop;
  
      setTableHeight(parentHeight - topOffset);
    };
  
    updateHeight();
  
    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(parent);
  
    return () => resizeObserver.disconnect();
  }, []);
  const handleSave = () => {
    if (Number(selectedWeight) > Number(maximumWeight)) {
      setShowOverloadConfirmation(true)
      // setAlert({
      //   show: true,
      //   msg: `Not Allowed to plan dispatch with overload capacity,Overload amount: ${overloadAmount} KG`,
      // })
      // return
    }else{
      onSave()
    }
  }

  const overloadConfirmationPopup = () => {
    const data = {
      successMessage: 'You are planning dispatch with overload capacity. Are you sure you want to proceed with Overload?',
      otherMessage: `Overload amount: ${overloadAmount} KG`,
      yesAction: () => {
        setShowOverloadConfirmation(false)
        onSave()
      },
      noAction: () => setShowOverloadConfirmation(false),
    }
    return <SuccessPopUp data={data} updateModal={setShowOverloadConfirmation} />
  }

  if (!open) return null

  return (
    <Modal width="92%" height="85%" headTxt={mode === 'add' ? 'ADD LOAD' : 'MANAGE LOAD'} updateModal={onClose}>
      <Box p={2} sx={{ height: 'calc(100% - 52px)' }}>
        <Stack justifyContent="space-between" direction="row" gap={'10px'}>
          <div className={'input--wrapper'} style={{ width: '100%' }}>
            <LineinputV2
              label="Selected Live Trip"
              disabled={true}
              value={`${trip?.VehicleNo} | Trip ID: ${trip?.TripID} | Trip Date-Time: ${formatTripDateTime(trip)} | Trip Name: ${trip?.TripName}`}
            />
          </div>

          <Button
            variant="contained"
            className="btn btn-primary"
            sx={{
              height: '40px',
              minWidth: '220px',
            }}
            onClick={() => onLoadPendency(trip)}
            disabled={isLoading}
          >
            LOAD PENDENCY
          </Button>
        </Stack>
        {lrRows.length > 0 && (
          <Stack direction={{ xs: 'column', lg: 'row' }} spacing={3} mb={2} mt={1} justifyContent="space-between">
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3}>
              <div className={'input--wrapper'} style={{ width: '100%' }}>
                <LineinputV2 disabled label="Maximum Weight(KG)" value={maximumWeight} />
              </div>
              <div className={'input--wrapper'} style={{ width: '100%' }}>
                <LineinputV2 disabled label="Loaded Weight(KG)" value={loadedWeight} />
              </div>
              <div className={'input--wrapper'} style={{ width: '100%' }}>
                <LineinputV2 disabled label="Available Weight(KG)" value={availableWeight} />
              </div>
              <div className={'input--wrapper'} style={{ width: '100%' }}>
                <LineinputV2 disabled label="Selected Weight(KG)" value={selectedWeight} />
              </div>
            </Stack>

            <Stack direction="row" spacing={2} alignItems="center">
              <Button
                variant="contained"
                onClick={handleSave}
                className="btn btn-primary"
                sx={{
                  height: '40px',
                  minWidth: '220px',
                }}
              >
                {mode === 'add' ? 'Save Plan' : 'Update Plan'}
              </Button>

              <Button
                variant="outlined"
                color="error"
                onClick={onClose}
                sx={{
                  minWidth: 170,
                }}
              >
                Cancel
              </Button>
            </Stack>
          </Stack>
        )}
        {lrRows.length > 0 && <Box ref={containerRef}
          sx={{ overflowX: 'scroll', height: tableHeight }}>
          <LRTable rows={lrRows} mode={mode} onSelectionChange={onSelectionChange} showTotals />
        </Box>}
      </Box>
      {showOverloadConfirmation && overloadConfirmationPopup()}
    </Modal>
  )
}

export default LoadEditorModal
